import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    justify-content: space-between;
  }
`;

export const TabTitle = styled.h2`
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black9};
  font-feature-settings: 'liga' off, 'clig' off;
  text-overflow: ellipsis;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: -0.2px;
  display: none;
  margin: 0;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    display: flex;
  }
`;

export const ActionsWrapper = styled.div`
  display: flex;
  gap: 16px;
`;

export const ProfileData = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;
